(function () {
  try {
    if (window.PNM && window.PNM.scentInjectorEnabled === false) {
      return;
    }
  } catch (e) {}
  try {
    if (window.Shopify && Shopify.designMode) {
      throw new Error('design-mode');
    }
  } catch (e) {
    /* stop in editor */
  }

  (function () {
    var CACHE = Object.create(null);
    function productHandleFromHref(href) {
      try {
        var u = new URL(href, location.origin);
        var parts = u.pathname.split('/').filter(Boolean);
        var idx = parts.indexOf('products');
        if (idx >= 0 && parts[idx + 1]) {
          return parts[idx + 1].replace(/\/+$/, '').split('?')[0];
        }
      } catch (e) {}
      return null;
    }
    function fetchScent(handle) {
      if (!handle) return Promise.resolve('');
      if (CACHE[handle] !== undefined) return Promise.resolve(CACHE[handle]);
      return fetch('/products/' + handle + '?view=pnm-scent', {
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          var trimmed = (html || '').replace(/^\s+|\s+$/g, '');
          CACHE[handle] = trimmed;
          return trimmed;
        })
        .catch(function () {
          return '';
        });
    }

    function dedupe(cardEl) {
      // Hide any existing Scent/Quick Description accordions not created by us
      var details = cardEl.querySelectorAll('details');
      details.forEach(function (d) {
        if (d.classList && d.classList.contains('pnm-acc')) return;
        var sum = d.querySelector('summary');
        if (!sum) return;
        var t = (sum.textContent || '').trim().toLowerCase();
        if (t === 'scent description' || t === 'quick description') {
          d.style.display = 'none';
        }
      });
      // Also hide common theme accordion blocks with matching headers
      var headers = cardEl.querySelectorAll(
        '.accordion-header, .summary__title, .product-block__accordion summary'
      );
      headers.forEach(function (h) {
        var t = (h.textContent || '').trim().toLowerCase();
        if (t === 'scent description' || t === 'quick description') {
          var dd = h.closest('details');
          if (dd && !dd.classList.contains('pnm-acc'))
            dd.style.display = 'none';
        }
      });
    }

    function insertAccordion(cardEl, html) {
      if (!html) return;
      if (cardEl.querySelector('.pnm-acc')) return;
      var details = document.createElement('details');
      details.className = 'pnm-acc';
      var sum = document.createElement('summary');
      sum.innerHTML =
        '<svg class="pnm-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false" width="10" height="6"><path d="M1 1.25l4 3.5 4-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Scent Description';
      var body = document.createElement('div');
      body.className = 'pnm-scent-body';
      body.innerHTML = html;
      details.appendChild(sum);
      details.appendChild(body);
      // Find a good anchor: after the product title if present
      var titleEl = cardEl.querySelector(
        '.mz-item-title, .product-block__title, .card__heading, .product-title, .product-card__title, .mz-item-info .title, h3 a[href*="/products/"], h3 .full-unstyled-link'
      );
      if (titleEl && titleEl.parentElement) {
        var anchorParent = titleEl.parentElement;
        if (titleEl.nextSibling) {
          anchorParent.insertBefore(details, titleEl.nextSibling);
        } else {
          anchorParent.appendChild(details);
        }
      } else {
        var priceEl = cardEl.querySelector('.price, .price__container');
        if (priceEl && priceEl.parentElement) {
          priceEl.parentElement.insertBefore(details, priceEl);
        } else {
          var inner =
            cardEl.querySelector('.mz-item-inner') ||
            cardEl.querySelector('.mz-item-card') ||
            cardEl;
          inner.appendChild(details);
        }
      }
      dedupe(cardEl);
    }
    function isInNav(el) {
      return !!(
        el &&
        el.closest(
          'header, nav, .site-header, .header__menu, .mega-menu, .site-nav, .navigation, .header__inline-menu'
        )
      );
    }

    function findCardForLink(a) {
      if (!a) return null;
      var sel = [
        '.product-card',
        '.card-wrapper',
        '.grid__item',
        '.product-block',
        '.mz-grid-item',
        '.mz-item-card',
        '.product-grid-item',
        'li',
        '.card',
        '.grid-product',
      ];
      for (var i = 0; i < sel.length; i++) {
        var c = a.closest(sel[i]);
        if (c) return c;
      }
      return a.parentElement;
    }

    function processCard(cardEl) {
      if (isInNav(cardEl)) return;
      var a = cardEl.querySelector('a[href*="/products/"]');
      var handle = a ? productHandleFromHref(a.getAttribute('href')) : null;
      if (!handle) return;
      fetchScent(handle).then(function (html) {
        if (html) insertAccordion(cardEl, html);
      });
    }
    function scan(root) {
      var nodes = (root || document).querySelectorAll(
        '.mz-grid-item, .mz-item-card, .product-grid-item, .product-card, .card-wrapper, .grid__item, .product-block'
      );
      // Also parse anchors in product recommendations directly
      var recAnchors = (root || document).querySelectorAll(
        '.product-recommendations a[href*="/products/"], [data-section-type*="product-recommendations"] a[href*="/products/"]'
      );
      recAnchors.forEach(function (a) {
        var card = findCardForLink(a);
        if (card && !isInNav(card))
          nodes = Array.from(new Set([].concat(Array.from(nodes), [card])));
      });
      if (!nodes.length) return;
      nodes.forEach(function (card) {
        if (!isInNav(card)) processCard(card);
      });
    }
    function ready(fn) {
      if (
        document.readyState === 'complete' ||
        document.readyState === 'interactive'
      ) {
        fn();
      } else document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
    function observe() {
      var container =
        document.querySelector('#MainContent') ||
        document.querySelector('.page-width') ||
        document.querySelector('.mz-results') ||
        document.querySelector('#mezeron-app') ||
        document.querySelector('.product-recommendations') ||
        document.querySelector(
          '[data-section-type*="product-recommendations"]'
        );
      if (!container) return;
      var mo = new MutationObserver(function (muts) {
        scan(container);
      });
      mo.observe(container, { childList: true, subtree: true });
    }
    ready(function () {
      scan(document);
      // run a dedupe pass on initial load
      var cards = document.querySelectorAll(
        '.mz-grid-item, .mz-item-card, .product-grid-item, .product-card, .card-wrapper, .grid__item'
      );
      cards.forEach(function (c) {
        dedupe(c);
      });
      /* recs dedupe pass */
      var recCards = document.querySelectorAll(
        '.product-recommendations .product-card, .product-recommendations .card-wrapper, [data-section-type*="product-recommendations"] .card-wrapper'
      );
      recCards.forEach(function (c) {
        dedupe(c);
      });
      observe();
    });
  })();
})();
// Ensure £ symbol prefixed on dynamic price updates
document.addEventListener('price:update', function (e) {
  if (e && e.detail && e.detail.element) {
    e.detail.element.textContent =
      '£' + e.detail.element.textContent.replace('£', '');
  }
});

// Force all .price elements inside collections/upsells to show £
function enforcePoundSymbol() {
  document
    .querySelectorAll('.price, .product-price, .money')
    .forEach(function (el) {
      if (el.textContent && !el.textContent.trim().startsWith('£')) {
        el.textContent = '£' + el.textContent.trim().replace('£', '');
      }
    });
}
document.addEventListener('DOMContentLoaded', enforcePoundSymbol);
document.addEventListener('price:update', enforcePoundSymbol);
